import AbstractBaseError from './AbstractBaseError';

export default class ModelNotFoundException extends AbstractBaseError {
	name = 'ModelNotFoundException';
}
